import React, { useEffect, useState } from 'react';
import LoginForm from './loginForm';
import rovquest_logo from 'assets/images/rovquest_logo_primary.png';
import MainOnboard from './mainOnboard';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

/** ログイン画面で選べる言語。値は i18n の言語の名前、表示は JP / EN。 */
const LANGUAGES = [
  { lang: 'jp', label: 'JP' },
  { lang: 'en', label: 'EN' },
] as const;

const Login: React.FC = () => {
  const { t } = useTranslation('common');
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'jp'
  );

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <div className="flex min-h-screen">
      <img
        src={rovquest_logo}
        alt="RovQuest Logo"
        className="fixed top-8 left-6 w-64 h-16"
      />

      {/* 2026-11-03 UAT A01（和田様）。国旗つきの2つのボタンをやめ、JP / EN を一覧から選ぶプルダウンにした。
          文字は枠の中央にそろえる。 */}
      <div className="fixed top-8 right-1/2 mr-20">
        <select
          aria-label={t('ui.language')}
          value={language}
          onChange={(event) => handleLanguageChange(event.target.value)}
          className="w-28 cursor-pointer rounded-md border border-gray-300 bg-white px-3 py-2 text-center text-neutral/200"
          style={{ textAlignLast: 'center' }}
        >
          {LANGUAGES.map(({ lang, label }) => (
            <option key={lang} value={lang}>
              {label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex-1 flex items-center">
        <LoginForm />
      </div>

      <MainOnboard />
    </div>
  );
};

export default Login;
